// Utilities
import { createSimpleFunctional } from "../../util/index.mjs";
export const VAlertTitle = createSimpleFunctional('v-alert-title');
//# sourceMappingURL=VAlertTitle.mjs.map